import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/src/client_pages/Index.tsx");
